/**
 * §6.6 Workspace & User Management — six admin capabilities.
 */

import React from 'react'
import {
  ServerCog, MailPlus, ShieldCheck, UsersRound, ToggleRight, KeyRound, Sparkles,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { WORKSPACE_MGMT } from '../data'

const ICONS = { ServerCog, MailPlus, ShieldCheck, UsersRound, ToggleRight, KeyRound, Sparkles }

export default function Workspace() {
  return (
    <section className="relative py-24 md:py-28">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent" />
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Workspace &amp; User Management</Eyebrow>
          <SectionHeading align="center"
            title={<>Multi-tenant workspaces{' '}<span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">out of the box.</span></>}
            subtitle="Every white-label tenant runs on the same enterprise-grade multi-tenant fabric — with the same SSO, RBAC and audit-log posture used by Kalki Ai Cloud itself."
          />
        </div>
        <FeatureGrid items={WORKSPACE_MGMT} icons={ICONS} cols={3} />
      </Container>
    </section>
  )
}
